var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"flex border-b border-gray-200"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.id,staticClass:"px-4 py-2 text-base font-medium border-b-2",class:_vm.activeTab === tab.id
				? 'text-gray-900 border-gray-900'
				: 'text-gray-500 border-transparent',attrs:{"type":"button","data-test":tab.testId},on:{"click":function($event){return _vm.$emit('select', tab.id)}}},[_vm._v("\n\t\t"+_vm._s(tab.label)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }